export default {
    'delete-message': 'هل أنت متأمد أنك تريد حذف هذه المهارة ؟',
    'add-skill': 'إضافة مهارة',
    headers: {
        skill: 'مهارة'
    }
}